import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { useRequiredFields } from "../../../../../theme/Component/hooks/useRequiredFields";
import { SelectTypeNovelty } from "../../../../../Talentohumano/Novelty/TypeNovelty/SelectTypeNovelty";
import { AtachDocument } from "../../../../../theme/Component/AtachDocument";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectIDContractSingleton } from "../../../../../admin/select/SelectIDContractSingleton";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOLPER001 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};
    const contract: any = _single.getMyEmployeeContract() ?? {};

    const { instance } = useDataBean(_NoveltyAccount)
    const { instance: instanceArea } = useDataBean(_FunctionalID)

    const [areaData, setAreaData] = useState<any>(null);
    const [isBoss, setIsBoss] = useState(false);
    const [selectedContract, setSelectedContract] = useState<any>(null);

    const [bean, setBean] = useState<any>({
        IDAccount: _single.getAccountID(),
        IDEmployee: _single.getAccountID(),
        State: 100,
        IDProcedureIMP: procedure?.IDProcedureImp,
    });

    useEffect(() => {
        if (contract.length === 1) {
            const c = contract[0];
            setSelectedContract(c);

            if (c.FunctionalIDJsonCode) {
                resolveData(c.FunctionalIDJsonCode);
            }
        }
    }, [contract]);

    const handleContractChange = (c: any) => {
        setSelectedContract(c);

        setBean(prev => ({
            ...prev,
            IDContract: c.IDContract
        }));
        if (c.FunctionalIDJsonCode) {
            resolveData(c.FunctionalIDJsonCode);
        }
    };

    const resolveData = (jsonArea: string) => {
        instanceArea.getFunctionalIDByCode(jsonArea).then(
            (resp) => {
                setAreaData(resp);

                const accountID = _single.getAccountID();
                setIsBoss(resp.IDBoss === accountID);
            }
        ).catch(() => {
            toast.error("No se pudo obtener la informacion del area");
        });
    };

    const { missingFields, validate } = useRequiredFields(bean, ["DescriptionRequest"]);

    const onExportMap = (responseObj: any) => {
        const resumen = document.map((doc, index) => {
            return `${doc?.Name ?? doc.Media}`;
        }).join("; ");

        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Tipo de Novedad": bean.RenderType ?? "N/A",
                "Solicitud": responseObj.DescriptionRequest,
                "Documentos Cargados": resumen ?? "No Presenta",
            })
        );

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(responseObj)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ ...responseObj, AssignTo: responseObj.IDAprove })
        }
    }



    const createRequestBoss = () => {

        if (validate() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        if (!areaData) {
            toast.error("No se encuentra un Área asociada al contrato");
            return;
        }

        return instanceArea.getFunctionalIDByKey(areaData.IDLn)
            .then(response => {

                if (!response.IDLn_1) {
                    toast.error("No se pudo consultar el area jefe");
                    return;
                }

                instanceArea.getFunctionalIDByKey(response.IDLn_1).then(
                    (resp) => {
                        if (resp.IDBoss) {
                            const x = {
                                ...bean,
                                ApplicationDate: _single.getCurrenDate(),
                                IDAprove: resp.IDBoss,
                                IDFunctionalAreaFrom: areaData.IDLn,
                                IDFunctionalAreaTo: resp.IDLn
                            };

                            createRequest(x);

                        } else {
                            toast.error("Jefe no configurado");
                        }
                    }
                ).catch(() => {
                    toast.error("No se pudo cargar la area del jefe");
                });

            })
            .catch(() => null);
    };

    const createRequestEmployee = () => {
        if (validate() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        if (!areaData) {
            toast.error("No se encuentra un Área asociada al contrato");
            return;
        }

        const x = {
            ...bean,
            ApplicationDate: _single.getCurrenDate(),
            IDAprove: areaData.IDBoss,
            IDFunctionalAreaFrom: areaData.IDLn,
            IDFunctionalAreaTo: areaData.IDLn
        };
        createRequest(x);
    };

    const createRequest = (obj: any) => {
        console.log(obj)
        instance.updateNoveltyAccount(obj).then(
            (resp) => {
                onExportMap(resp);
            }
        ).catch(err => { toast.error(err) })
    }

    const [document, setDocument] = useState<any>([]);

    useEffect(() => {
        setBean(prev => ({ ...prev, Attach: JSON.stringify(document) }));
    }, [document]);

    return (
        <div className="row">
            {contract.length > 1 &&
                <div className="col-md-12">
                    <SelectIDContractSingleton
                        idSelector={bean.IDContract}
                        returnType="Object"
                        onChange={handleContractChange}
                    />
                </div>
            }
            <div className="col-md-12">
                <SelectTypeNovelty returnType="Object" idSelector={bean.IDTypeNovelty} onChange={(e) => { setBean({ ...bean, IDTypeNovelty: e.IDTypeNovelty, RenderType: e.EntityName }) }} />
            </div>
            <div className="col-md-12">
                <label>Descripción de la solicitud</label>
                <textarea className="form-control" value={bean.DescriptionRequest} onChange={(e) => { setBean({ ...bean, DescriptionRequest: e.target.value }) }} />
            </div>
            <div className="col-md-12">
                <AtachDocument _docList={document} onChange={(e) => { setDocument(e) }} />
            </div>
            <div className="col-md-12">
                <BasicButton useMargin eventClick={() => { isBoss ? createRequestBoss() : createRequestEmployee() }} icon="ri-send-plane" children={`Enviar solicitud`} />
            </div>
        </div>
    );
}